"use client";

import React, { FunctionComponent, useState } from "react";
import Image from "next/image";
import { AssetDetails } from "contentful";
import ReactPlayer from "react-player";

import { IVideo, IVideoFields } from "@/types/generated/contentful";

type Props = {
  content: IVideo;
};

const Video: FunctionComponent<Props> = ({ content }) => {
  const [isPlaying, setPlay] = useState(false);

  const { url, image } = content.fields as IVideoFields;

  const openVideo = () => {
    setPlay(true);
  };

  if (!url || url === undefined) return <></>;

  return (
    <div className="mx-auto my-8 w-full max-w-3xl">
      <div className="relative aspect-video rounded-lg shadow-lg md:overflow-hidden">
        {isPlaying ? (
          <ReactPlayer
            url={url}
            width="100%"
            height="100%"
            playing={isPlaying}
            controls
            className="absolute left-0 top-0"
          />
        ) : image && !isPlaying ? (
          <div className="absolute left-0 top-0 h-full w-full">
            <div className="absolute right-1/2 top-1/2 z-10 -translate-y-1/2 translate-x-1/2 transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-90">
              <Image
                src="/icons/play_button.svg"
                className="h-10 w-10 cursor-pointer md:h-16 md:w-16"
                alt="Play Video"
                width={68}
                height={68}
                onClick={() => openVideo()}
              />
            </div>
            <Image
              src={`https:${image.fields.file?.url}`}
              className="h-full w-full cursor-pointer rounded-lg object-cover"
              alt={image.fields.description as string}
              width={(image.fields.file?.details as AssetDetails).image?.width}
              height={
                (image.fields.file?.details as AssetDetails).image?.height
              }
              onClick={() => openVideo()}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Video;
